import React, { useState, useEffect } from "react";
import { createBatchDO } from "../../../utils/questionsUtils";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { EnumAutocomplete } from "components/alove/EnumAutocomplete";
import { Batch, BatchType } from "models/batch/Batch";

const MDInput = require("components/MDInput").default;

export default function AddQuestionnaireModal() {

  const [batch, setBatch] = useState({} as Batch);

  const addQuestionnaire = async () => {
    createBatchDO(batch)
  };

  return (
    <AloveDialog
      dialogType={DialogType.AddQuestionnaire}
      dialogTitle="Add Questionnaire"
      handleConfirm={addQuestionnaire}
      dialogConfirm="Add"
      valid={!!batch?.name && !!batch?.displayName && !!batch?.batchType}
    >

      <MDInput
        label="key"
        placeholder="key"
        value={batch?.name}
        onChange={(e) => setBatch({ ...batch, name: e?.target?.value })}
      />
      <MDInput
        label="Display name"
        placeholder="Display name"
        value={batch?.displayName}
        onChange={(e) => setBatch({ ...batch, displayName: e?.target?.value })}
      />

      <MDInput
        label="Description"
        value={batch?.description}
        placeholder="Description"
        onChange={(e) => setBatch({ ...batch, description: e?.target?.value })}
        fullWidth
      />
      <EnumAutocomplete
        enumName={BatchType}
        value={batch.batchType}
        onChange={(value) => setBatch({ ...batch, batchType: value })}
      />
    </AloveDialog>
  );
}
